import React from "react";

const MyProfile = () => {
  return (
    <div className="overflow-scroll h-[100%] p-4">
      <h1 className="text-2xl font-bold">Profile Content hj</h1>
    </div>
  );
};

export default MyProfile;
